export default __webpack_public_path__ + "static/home_slider2.png";